import { BAlert, BButton, BCard } from '../../../../components/ui/generic';
import { useForm } from 'react-hook-form';
import { useHandleSubmitTunnel } from '../../../../hooks/useHandleSubmitTunnel';
import { Link, useParams } from 'react-router';
import useUser from '../../../../hooks/User';
import { useDevice, usePedagogical, useSchoolLevel, useSituationPro } from '../../../../hooks/Settings';
import BSelect from '../../../../components/ui/form/BSelect';
import BTextarea from '../../../../components/ui/form/BTextarea';
import PedagogicalField from './PedagogicalField';
import { BCheckbox, BInputError, BRadio } from '../../../../components/ui/form';
import { useTrainingInfoById } from '../../../../hooks/Training';
import React, { useEffect } from 'react';
import Qualiopi from './Qualiopi';
import { IconChevronLeft } from '@tabler/icons-react';
import { requiredField } from '../../../../utils';

const Eligibilite = () => {
  const { trainingId } = useParams();
  const { data: training, isSuccess: training_isSuccess } = useTrainingInfoById(trainingId);

  const { data: user, isSuccess: user_isSuccess } = useUser();
  const { data: situationPro, isSuccess: situationPro_isSuccess } = useSituationPro();
  const { data: schoolLevel, isSuccess: schoolLevel_isSuccess } = useSchoolLevel();
  const { data: pedagogical, isSuccess: pedagogical_isSuccess } = usePedagogical();
  const { data: devices, isSuccess: devices_isSuccess } = useDevice();

  const {
    watch,
    setValue,
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();
  useEffect(() => {
    function transformData(data) {
      data.forEach((item) => {
        if (item.response !== null) {
          setValue(item.identifier, item.response_id + '');
          if (item.need_additional) {
            setValue(`${item.identifier}Details`, item.additionnal_info);
          }
        } else {
          setValue(item.identifier, item.additionnal_info);
        }
      });
    }
    if (!user_isSuccess || !training_isSuccess) return;
    setValue(
      'qualiopi',
      training?.training_qualification?.qualiopi?.id ? training?.training_qualification?.qualiopi?.id + '' : ''
    );
    setValue(
      'qualiopiDetails',
      training?.training_qualification?.qualiopi_answer_detail
        ? training?.training_qualification?.qualiopi_answer_detail + ''
        : ''
    );
    if (training?.user?.user_qualification) {
      const uql = training?.user?.user_qualification;

      transformData(uql.pedagogical);
      setValue('internetConnexion', uql?.has_internet_connexion !== undefined ? uql?.has_internet_connexion + '' : '');
      setValue(
        'device',
        uql?.device.map((d) => d + '')
      );
    }
    if (situationPro_isSuccess)
      if (user.situation_pro) {
        const tmp = situationPro.find((sp) => sp.name === user.situation_pro).id;
        setValue('proSituation', tmp);
      }
    if (schoolLevel_isSuccess)
      if (user.school_level) {
        const tmp = schoolLevel.find((sc) => sc.name === user.school_level).id;
        setValue('schoolLevel', tmp);
      }
  }, [
    training,
    user,
    user_isSuccess,
    training_isSuccess,
    situationPro,
    situationPro_isSuccess,
    schoolLevel,
    schoolLevel_isSuccess,
    setValue,
  ]);

  const situationProWatch = watch('proSituation');
  const qualiopiWatch = watch('qualiopi');
  const hasExperienceProSimilaireWatch = watch('hasExperienceProSimilaire');
  const hasFrenchDifficultyWatch = watch('hasFrenchDifficulty');
  const hasSocialDifficultyWatch = watch('hasSocialDifficulty');

  const isComfortableWithDigitalToolsWatch = watch('isComfortableWithDigitalTools');
  const onSubmit = useHandleSubmitTunnel('eligibilite', trainingId);
  return (
    <BCard maxSize={'md:max-w-2xl font-normal'}>
      <BCard.Header title={'Étape 2 : Éligibilité'} withTitle>
        <p className={'text-sm'}>Tous les champs sont obligatoires</p>
      </BCard.Header>
      <BCard.Body>
        <form
          id={'tunnelFormStep1'}
          onSubmit={handleSubmit(onSubmit)}
          className={'flex flex-col gap-6 px-4 sm:max-w-md'}
        >
          <input hidden defaultValue={'next'} {...register('submit')} />
          <input hidden defaultValue={''} {...register('question_job')} />
          <input hidden defaultValue={''} {...register('question_pe')} />
          <input hidden defaultValue={''} {...register('question_ml')} />
          <div className={'flex flex-col gap-4'}>
            {situationPro_isSuccess && (
              <BSelect
                errors={errors.proSituation}
                {...register('proSituation', { required: { value: true, message: requiredField } })}
                options={situationPro}
                label={'Situation professionnelle'}
              />
            )}

            <BTextarea
              minLength={-1}
              maxLength={-1}
              errors={errors.proSituationDetails}
              isHidden={situationProWatch !== '1'}
              type={'textarea'}
              {...register('proSituationDetails', {
                required: { value: situationProWatch === '1', message: requiredField },
              })}
              label={'Détails'}
            />
            {schoolLevel_isSuccess && (
              <BSelect
                errors={errors.schoolLevel}
                {...register('schoolLevel', { required: { value: true, message: requiredField } })}
                options={schoolLevel}
                label={"Quel est votre niveau d'étude le plus élevé ?"}
              />
            )}

            {pedagogical_isSuccess && (
              <PedagogicalField
                errors={errors.longTermProject}
                name={'longTermProject'}
                register={register}
                pedagogicalPositioning={pedagogical.longTermProject}
              />
            )}
            {pedagogical_isSuccess && (
              <PedagogicalField
                errors={errors.hasExperienceProSimilaire}
                register={register}
                details={'hasExperienceProSimilaireDetails'}
                pedagogicalPositioning={pedagogical.hasExperienceProSimilaire}
                name={'hasExperienceProSimilaire'}
              />
            )}
            <BTextarea
              minLength={-1}
              maxLength={-1}
              errors={errors.hasExperienceProSimilaireDetails}
              isHidden={hasExperienceProSimilaireWatch !== '1'}
              {...register('hasExperienceProSimilaireDetails', { required: hasExperienceProSimilaireWatch === '1' })}
              placeholder={'Précisez'}
            />

            {pedagogical_isSuccess && (
              <PedagogicalField
                errors={errors.hasRqth}
                register={register}
                pedagogicalPositioning={pedagogical.hasRqth}
                name={'hasRqth'}
              />
            )}
          </div>
          {training_isSuccess && (
            <Qualiopi qualiopi={qualiopiWatch} categoryId={training.category_id} register={register} errors={errors} />
          )}
          <div className={'bg-primary-50 flex flex-col gap-4 p-6'}>
            <div className={'flex flex-col gap-1'}>
              <p className={'text-sm font-medium text-slate-700'}>Disposez-vous d'une connexion internet ?</p>
              <div className={'flex flex-col gap-2 sm:flex-row'}>
                <BRadio
                  value={1}
                  label={'Oui'}
                  id={'internetYes'}
                  {...register('internetConnexion', { required: { value: true, message: requiredField } })}
                />
                <BRadio value={0} label={'Non'} id={'internetNo'} {...register('internetConnexion')} />
              </div>
              <BInputError errors={errors.internetConnexion} />
            </div>
            <div className={'flex flex-col gap-1'}>
              <p className={'w-full text-sm font-medium'}>Sur quel matériel travaillez-vous ?</p>
              {devices_isSuccess && (
                <div className={'flex flex-col gap-1 sm:gap-2 sm:flex-row'}>
                  {devices.map((device) => {
                    return (
                      <BCheckbox
                        key={device.id}
                        id={device.name}
                        value={device.id}
                        label={device.name}
                        {...register('device', { required: { value: true, message: requiredField } })}
                      />
                    );
                  })}
                </div>
              )}
              <BInputError errors={errors.device} />
            </div>
            {pedagogical_isSuccess && (
              <PedagogicalField
                errors={errors.isComfortableWithDigitalTools}
                pedagogicalPositioning={pedagogical.isComfortableWithDigitalTools}
                name={'isComfortableWithDigitalTools'}
                register={register}
              />
            )}
            {(isComfortableWithDigitalToolsWatch === '6' || isComfortableWithDigitalToolsWatch === '7') &&
              pedagogical_isSuccess && (
                <PedagogicalField
                  errors={errors.needSpecificHelp}
                  register={register}
                  pedagogicalPositioning={pedagogical.needSpecificHelp}
                  name={'needSpecificHelp'}
                />
              )}
          </div>
          <div className={'flex flex-col gap-4'}>
            {pedagogical_isSuccess && (
              <PedagogicalField
                errors={errors.hasSocialDifficulty}
                pedagogicalPositioning={pedagogical.hasSocialDifficulty}
                name={'hasSocialDifficulty'}
                register={register}
              />
            )}
            <BTextarea
              minLength={-1}
              maxLength={-1}
              errors={errors.hasSocialDifficultyDetails}
              isHidden={hasSocialDifficultyWatch !== '9'}
              {...register('hasSocialDifficultyDetails', {
                required: { value: hasSocialDifficultyWatch === '9', message: requiredField },
              })}
              placeholder={'Précisez'}
            />

            {pedagogical_isSuccess && (
              <PedagogicalField
                errors={errors.hasFrenchDifficulty}
                pedagogicalPositioning={pedagogical.hasFrenchDifficulty}
                name={'hasFrenchDifficulty'}
                register={register}
              />
            )}
            <BTextarea
              errors={errors.hasFrenchDifficultyDetails}
              isHidden={hasFrenchDifficultyWatch !== '3'}
              {...register('hasFrenchDifficultyDetails', {
                required: { value: hasFrenchDifficultyWatch === '3', message: requiredField },
              })}
              placeholder={'Précisez'}
            />
          </div>
        </form>
        <div className={'flex items-center justify-between'}>
          <div>
            <Link to={`/inscription/informations/${trainingId}`} className={'hover:text-primary-700 flex items-center'}>
              <IconChevronLeft className={'size-5'} /> <p className={'text-sm'}>Retour</p>
            </Link>
          </div>
          <div>
            <BButton
              isProcessing={isSubmitting}
              isDisabled={isSubmitting}
              form={`tunnelFormStep1`}
              size={'base'}
              type={'submit'}
              label={'Suivant'}
            />
          </div>
        </div>
      </BCard.Body>
    </BCard>
  );
};

export default Eligibilite;
